<template>
    <div class="container-fluid d-flex vh-100 bg-white">
        <div class="h-100 d-flex flex-grow-1 col-lg-6">
            <div class="mx-auto my-auto col-sm-12 col-lg-9">
                <form id="register-form" @submit.prevent="" class="mt-5">
                    <div>
                        <svg class="mb-4" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 35.378 39.315">
                            <g id="Grupo_69" data-name="Grupo 69" transform="translate(-481.81 380)">
                                <g id="Grupo_68" data-name="Grupo 68" transform="translate(481.81 -380)">
                                    <rect id="Retângulo_39" data-name="Retângulo 39" width="5.56" height="22.238"
                                            transform="translate(31.447 19.656) rotate(45)" fill="#00dbf9"></rect>
                                    <path id="Caminho_94" data-name="Caminho 94"
                                            d="M509.329-372.137l-3.931-3.931L501.466-380l-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931,3.931,7.863,7.863,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931Zm-11.794,11.794-3.931,3.931-3.931-3.931,3.931-3.931,3.931-3.931,3.931-3.931,3.931,3.931Z"
                                            transform="translate(-481.81 380)" fill="#3839e3"></path>
                                    <rect id="Retângulo_40" data-name="Retângulo 40" width="5.56" height="11.119"
                                            transform="translate(11.792 31.453) rotate(-45)" fill="#0195ff"></rect>
                                </g>
                            </g>
                        </svg>
                    </div>

                    <p>
                        <small class="text-primary h6">
                            Passo {{ actualStep + 1 }} de {{ pages.length }}
                        </small>
                    </p>
                    <p class="h2 w-100">
                        <strong>
                            {{pages[actualStep].title}}
                        </strong>
                    </p>
                    <p class="text-dark">
                        {{ pages[actualStep].subtitle }}
                    </p>

                    <div class="alert alert-danger mb-3" v-show="errorSession">
                        {{ errorSession }}
                    </div>

                    <div v-if="actualStep === 0">
                        <div class="form-group">
                            <label for="organization">Nome da Escola</label>
                            <input
                                id="organization"
                                type="text"
                                class="form-control"
                                :class="errors.organization ? 'is-invalid': ''"
                                placeholder="Ex: Cursinho Redação, Meu negócio"
                                autofocus
                                required
                                v-model="form.organization"
                                @blur="()=>{this.gerarNomes()}"
                            >

                            <has-errors :errors="errors" name="organization" />
                        </div>
                        <div class="form-group">
                            <div class="d-flex align-content-center">
                                <label for="domain">
                                    Url Exclusiva de Acesso
                                </label>
                                <div class="ml-1">
                                    <i class="fas fa-info-circle text-secondary pointer-event" id="infoUrlExclusiva"></i>

                                    <b-popover target="infoUrlExclusiva" triggers="hover" placement="bottom">
                                        Através deste endereço você e seus alunos poderão acessar o seu ambiente exclusivo.
                                        Para facilitar, você pode usar o nome da sua organização para usar como base na url.
                                        Recomendamos que use um nome curto para fácil memorização por você e seus alunos.
                                        Não use espaços, acentos, pontos ou caracteres especiais para evitar problemas de acesso.
                                        Segue aqui alguns exemplos de nomes válidos: <b>minha-escola, meunegocio, escola-x, etc...</b>
                                    </b-popover>
                                </div>
                            </div>

                            <div class="input-group">
                                <div class="input-group-prepend d-none d-sm-block">
                                    <div class="input-group-text">
                                        {{ urlScheme }}://
                                    </div>
                                </div>

                                <input
                                    id="domain"
                                    v-model="form.domain"

                                    type="text"
                                    class="form-control d-inline"
                                    :class="errors.domain ? 'is-invalid': ''"
                                    name="domain"
                                    autocomplete="domain"
                                    maxlength="30"
                                    autofocus

                                    placeholder="Ex: minhaescola, meu-negocio, escola-x">

                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        .{{ urlHost }}
                                    </div>
                                </div>
                            </div>

                            <span v-show="sugestNames.length > 0" class="">
                                <div class="d-flex">
                                    <p>Nomes sugeridos</p>
                                    <div class="ml-1">
                                        <i class="fas fa-info-circle text-secondary pointer-event" id="infoSugest"></i>

                                        <b-popover target="infoSugest" triggers="hover" placement="bottom">
                                            Os nomes sugeridos abaixo podem não estar disponivéis.
                                        </b-popover>
                                    </div>
                                </div>
                                <div class="row row-cols-2 gap-2 p-1">
                                    <div role="button" @click="()=>{form.domain = name}" class="col" v-for="(name,index) in sugestNames" :key="index">
                                        <p class="p-1 rounded bg-light text-primary">{{ name }}</p>
                                    </div>
                                </div>
                            </span>
                            <has-errors :errors="errors" name="domain" />
                        </div>

                        <div class="form-group">
                            <label for="relation">
                                Relação com a escola
                            </label>
                            <select name="relation" id="relation" class="custom-select" v-model="form.relation">
                                <option value="" disabled selected>Qual a relação com a escola?</option>
                                <option :value="relation" v-for="relation, index  in relations" :key="index">{{ relation }}</option>
                            </select>
                            <has-errors :errors="errors" name="relation" />
                        </div>

                        <div class="form-group">
                            <label for="sector">
                                Setor Educacional
                            </label>
                            <select name="sector" id="sector" class="custom-select" v-model="form.sector" >
                                <option value="" disabled selected>Qual o setor educacional?</option>
                                <option :value="sector" v-for="sector, index  in sectors" :key="index">{{ sector }}</option>
                            </select>
                            <has-errors :errors="errors" name="sector" />
                        </div>
                    </div>

                    <div v-if="actualStep === 1">
                        <div class="form-group">
                            <label for="name">
                                Nome
                            </label>
                            <input
                                id="name"
                                type="text"
                                :class="errors.name ? 'is-invalid': ''"
                                class="form-control"
                                autocomplete="name"
                                placeholder="Seu nome completo"
                                v-model="form.name"
                                autofocus>

                            <has-errors :errors="errors" name="name" />
                        </div>


                        <div class="form-group">
                            <label for="email">
                                Email
                            </label>

                            <input
                                id="email"
                                :class="errors.email ? 'is-invalid': ''"
                                class="form-control d-inline"
                                type="email"
                                autocomplete="email"
                                placeholder="Seu melhor email vai aqui"
                                v-model="form.email">

                            <has-errors :errors="errors" name="email" />
                        </div>
                        <div class="form-group">
                            <label for="phone">
                                Telefone
                            </label>

                            <the-mask
                                iud="phone"
                                type="tel"
                                :mask="['(##) #####-####', '(##) ####-####']"
                                :masked="true"
                                v-model="form.phone"
                                class="form-control"
                                :class="errors.phone ? 'is-invalid': ''"
                                placeholder="(DDD) Telefone Celular">
                            </the-mask>

                            <!-- Error -->
                            <has-errors :errors="errors" name="phone" />
                        </div>

                        <div class="form-group">
                            <div class="d-md-flex justify-content-between">
                                <div class="form-group mr-0 mr-sm-3">
                                    <label for="password">
                                        Senha
                                    </label>

                                    <input id="password" class="form-control d-inline" type="password" placeholder="Insira sua senha" v-model="form.password">

                                    <has-errors :errors="errors" name="password" />
                                </div>

                                <div class="form-group">
                                    <label for="password_confirmation">
                                        Confirmar Senha
                                    </label>

                                    <input id="password_confirmation" class="form-control d-inline" :class="errors.password ? 'is-invalid': ''" type="password" placeholder="Insira sua senha" v-model="form.password_confirmation">

                                    <has-errors :errors="errors" name="password_confirmation" />
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="terms-check" v-model="form.terms">
                                <label class="form-check-label" for="terms-check">Li e aceito os <a target="_blank" :href="linkTerms">Termos de Uso</a> e <a target="_blanck" :href="linkPolicity">Política de Privacidade</a> da plataforma</label>
                            </div>
                            <has-errors :errors="errors" name="terms" />
                        </div>
                    </div>
                </form>

                <!-- Mobile -->
                <div class="w-full mb-5 mt-2 d-block d-sm-none">
                    <button class="btn btn-primary btn-block mt-2 rounded-pill px-5 py-2" @click="onClickNext" :disabled="pages[actualStep].disabled && !isSubmiting">
                        <strong>
                            {{ pages[actualStep].btn }}
                        </strong>
                    </button>
                    <button class="btn btn-outline-primary btn-block rounded-pill px-5 py-2 mr-2" @click="onClickPrevious" v-if="actualStep !== 0">
                        <strong>
                            Voltar
                        </strong>
                    </button>
                </div>

                <!-- Desktop -->
                <div class="w-full mb-5 mt-2 d-none d-sm-block">
                    <button class="btn btn-outline-primary rounded-pill px-5 py-2 mr-2" @click="onClickPrevious" v-if="actualStep !== 0">
                        <strong>
                            Voltar
                        </strong>
                    </button>
                    <button class="btn btn-primary rounded-pill px-5 py-2" @click="onClickNext" :disabled="pages[actualStep].disabled && !isSubmiting">
                        <strong>
                            {{ pages[actualStep].btn }}
                        </strong>
                    </button>
                </div>

            </div>
        </div>
        <div class="side-image d-none d-sm-none d-md-none d-lg-flex p-2 col justify-content-end w-100">
            <img class="object-fit-scale min-w-50 image-size" src="/img/register.png" alt="">
        </div>

        <b-modal id="facebook-modal" title-class="text-center" hide-header hide-header-close centered hide-footer no-close-on-esc no-close-on-backdrop title="Em qual área você atua?">
            <div class="row text-center" style="margin: 10px 20px;">
                <div class="col-xs-12 col-lg-6">
                    <a @click.prevent="$bvModal.hide('facebook-modal')" class="btn btn-default" style="display: block; padding: 20px; border-radius: 6px; text-decoration: none; transition: background 0.3s, color 0.3s;">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 50px; height: 50px; margin: 0 auto;">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                        </svg>
                        <p style="font-size: 18px; font-weight: 500; margin: 10px auto;">Sou professor</p>
                    </a>
                </div>

                <div class="col-xs-12 col-lg-6">
                    <a href="https://testgratis.redacao.digital?utm_source=facebook" class="btn btn-default" style="display: block; padding: 20px; border-radius: 6px; text-decoration: none; transition: background 0.3s, color 0.3s;">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width: 50px; height: 50px;  margin: 0 auto;">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                        </svg>
                        <p style="font-size: 18px; font-weight: 500; margin: 10px auto;">Sou Aluno</p>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['endpointRegister', 'urlHost', 'urlScheme', 'linkTerms', 'linkPolicity', 'errorSession', 'sectors', 'relations', 'utmSource'],
    data() {
        return {
            actualStep: 0,
            sugestNames: [],
            form: {
                organization: '',
                domain: '',
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                relation: '',
                sector: '',
                terms: false,
                utm_source: this.utmSource // apenas para rastreio de origem para marketing
            },
            pages: [
                {
                    step : 0,
                    title : 'Preparado para ter as melhores experiências corrigindo as redações de seus alunos?',
                    subtitle: 'Precisaremos coletar algumas informações que são essências para configuração de sua conta',
                    btn: 'Avançar',
                    disabled: true,
                },
                {
                    step : 1,
                    title : 'Falta pouco para criar sua conta!',
                    subtitle: 'Preencha corretamente os campos solicitados, essas informações são importantes!',
                    btn: 'Cadastrar',
                    disabled: true,
                }
            ],
            errors: {},
            isSubmiting: false,
        }
    },
    created(){
        if (this.utmSource === 'facebook') {
            this.$nextTick(() => {
                fbq('track', 'PageView');
                this.$bvModal.show('facebook-modal')
            })
        }
    },
    watch:{
        'errors.domain'(value) {
            if (value) {
                this.actualStep = 0
            }
        },
        'errors.organization'(value) {
            if (value) {
                this.actualStep = 0
            }
        },
        'errors.relation'(value) {
            if (value) {
                this.actualStep = 0
            }
        },
        'errors.sector'(value) {
            if (value) {
                this.actualStep = 0
            }
        },
        'form.organization'() {
            this.pages[this.actualStep].disabled = !(this.form.organization !== '' && this.form.domain !== '');
        },
        'form.domain'(){
            this.pages[this.actualStep].disabled = !(this.form.organization !== '' && this.form.domain !== '');
        },
        'form.name'() {
            this.isPageFieldsNotEmpty()
        },
        'form.email'() {
            this.isPageFieldsNotEmpty()
        },
        'form.phone'() {
            this.isPageFieldsNotEmpty()
        },
        'form.password'() {
            this.isPageFieldsNotEmpty()
        },
        'form.password_confirmation'() {
            //
        }
    },

    methods: {
        gerarNomes() {
            this.sugestNames = [];
            const nomeFormatado = this.form.organization.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")

            // Gera sugestões de nomes
            const sugestoes = [
                nomeFormatado.replace(/\s/g, ''),
                nomeFormatado.replace(/\s/g, '-'),
                nomeFormatado.replace(/\s/g, '') + '-org',
                nomeFormatado.replace(/\s/g, '') + '-curso',
            ];
            this.sugestNames = sugestoes

        },
        isPageFieldsNotEmpty() {
            this.pages[this.actualStep].disabled = !(this.form.name !== '' && this.form.email !== '' && this.form.phone !== '' && this.form.password !== '');
        },

        onClickNext() {
            if ( this.actualStep <  (this.pages.length-1)) {
                this.actualStep += 1;
            } else {
                if(this.actualStep === this.pages.length-1){
                    this.onSubmit()
                }
            }
        },

        onClickPrevious() {
            this.actualStep -= 1;
        },

        onSubmit(e){
            this.errors = {}

            this.isSubmiting = true

            axios.post(this.endpointRegister, {
                ...this.form
            })
                .then((res) => {
                    let response = res.data;

                    if (response.success) {
                        if (this.utmSource === 'facebook') {
                            var hashedEmail = CryptoJS.SHA256(this.form.email.trim().toLowerCase()).toString()
                            // Enviar evento de Lead para o Facebook
                            fbq('track', 'Lead', {
                                content_name: this.form.organization,
                                content_category: this.form.sector,
                                em: hashedEmail, // Email hasheado
                                fn: this.form.name.split(" ")[0], // Primeiro nome
                                ln: this.form.name.split(" ").slice(1).join(" ") // Sobrenome
                            });
                        }

                        window.location.replace(response.redirect);
                    }
                })
                .catch((err) => {
                    this.errors = err.response.data.errors
                })
                .finally(() => {
                    this.isSubmiting = false
                })
        }
    }
}
</script>

<style scoped>
.side-image {
    max-width: 900px;
    width: 500px;
}
.image-size {
    width: auto;
    max-width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
}

@media (max-width: 1080px) {
    .side-image {
        display: none;
        width: 500px;
    }
}
</style>
